"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../geom/Location"));

var _EdgeEnd2 = _interopRequireDefault(require("./EdgeEnd"));

var _Position = _interopRequireDefault(require("./Position"));

var _TopologyException = _interopRequireDefault(require("../geom/TopologyException"));

var _Label = _interopRequireDefault(require("./Label"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DirectedEdge =
/*#__PURE__*/
function (_EdgeEnd) {
  _inherits(DirectedEdge, _EdgeEnd);

  function DirectedEdge() {
    var _this;

    _classCallCheck(this, DirectedEdge);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirectedEdge).call(this));
    DirectedEdge.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(DirectedEdge, [{
    key: "getNextMin",
    value: function getNextMin() {
      return this._nextMin;
    }
  }, {
    key: "getDepth",
    value: function getDepth(position) {
      return this._depth[position];
    }
  }, {
    key: "setVisited",
    value: function setVisited(isVisited) {
      this._isVisited = isVisited;
    }
  }, {
    key: "computeDirectedLabel",
    value: function computeDirectedLabel() {
      this._label = new _Label.default(this._edge.getLabel());
      if (!this._isForward) this._label.flip();
    }
  }, {
    key: "getNext",
    value: function getNext() {
      return this._next;
    }
  }, {
    key: "setDepth",
    value: function setDepth(position, depthVal) {
      if (this._depth[position] !== -999) {
        if (this._depth[position] !== depthVal) throw new _TopologyException.default("assigned depths do not match", this.getCoordinate());
      }

      this._depth[position] = depthVal;
    }
  }, {
    key: "isInteriorAreaEdge",
    value: function isInteriorAreaEdge() {
      var isInteriorAreaEdge = true;

      for (var i = 0; i < 2; i++) {
        if (!(this._label.isArea(i) && this._label.getLocation(i, _Position.default.LEFT) === _Location.default.INTERIOR && this._label.getLocation(i, _Position.default.RIGHT) === _Location.default.INTERIOR)) {
          isInteriorAreaEdge = false;
        }
      }

      return isInteriorAreaEdge;
    }
  }, {
    key: "setNextMin",
    value: function setNextMin(nextMin) {
      this._nextMin = nextMin;
    }
  }, {
    key: "print",
    value: function print(out) {
      _get(_getPrototypeOf(DirectedEdge.prototype), "print", this).call(this, out);

      out.print(" " + this._depth[_Position.default.LEFT] + "/" + this._depth[_Position.default.RIGHT]);
      out.print(" (" + this.getDepthDelta() + ")");
      if (this._isInResult) out.print(" inResult");
    }
  }, {
    key: "setMinEdgeRing",
    value: function setMinEdgeRing(minEdgeRing) {
      this._minEdgeRing = minEdgeRing;
    }
  }, {
    key: "isLineEdge",
    value: function isLineEdge() {
      var isLine = this._label.isLine(0) || this._label.isLine(1);

      var isExteriorIfArea0 = !this._label.isArea(0) || this._label.allPositionsEqual(0, _Location.default.EXTERIOR);

      var isExteriorIfArea1 = !this._label.isArea(1) || this._label.allPositionsEqual(1, _Location.default.EXTERIOR);

      return isLine && isExteriorIfArea0 && isExteriorIfArea1;
    }
  }, {
    key: "setEdgeRing",
    value: function setEdgeRing(edgeRing) {
      this._edgeRing = edgeRing;
    }
  }, {
    key: "getMinEdgeRing",
    value: function getMinEdgeRing() {
      return this._minEdgeRing;
    }
  }, {
    key: "getDepthDelta",
    value: function getDepthDelta() {
      var depthDelta = this._edge.getDepthDelta();

      if (!this._isForward) depthDelta = -depthDelta;
      return depthDelta;
    }
  }, {
    key: "setInResult",
    value: function setInResult(isInResult) {
      this._isInResult = isInResult;
    }
  }, {
    key: "getSym",
    value: function getSym() {
      return this._sym;
    }
  }, {
    key: "isForward",
    value: function isForward() {
      return this._isForward;
    }
  }, {
    key: "getEdge",
    value: function getEdge() {
      return this._edge;
    }
  }, {
    key: "printEdge",
    value: function printEdge(out) {
      this.print(out);
      out.print(" ");
      if (this._isForward) this._edge.print(out);else this._edge.printReverse(out);
    }
  }, {
    key: "setSym",
    value: function setSym(de) {
      this._sym = de;
    }
  }, {
    key: "setVisitedEdge",
    value: function setVisitedEdge(isVisited) {
      this.setVisited(isVisited);

      this._sym.setVisited(isVisited);
    }
  }, {
    key: "setEdgeDepths",
    value: function setEdgeDepths(position, depth) {
      var depthDelta = this.getEdge().getDepthDelta();
      if (!this._isForward) depthDelta = -depthDelta;
      var directionFactor = 1;
      if (position === _Position.default.LEFT) directionFactor = -1;

      var oppositePos = _Position.default.opposite(position);

      var delta = depthDelta * directionFactor;
      var oppositeDepth = depth + delta;
      this.setDepth(position, depth);
      this.setDepth(oppositePos, oppositeDepth);
    }
  }, {
    key: "getEdgeRing",
    value: function getEdgeRing() {
      return this._edgeRing;
    }
  }, {
    key: "isInResult",
    value: function isInResult() {
      return this._isInResult;
    }
  }, {
    key: "setNext",
    value: function setNext(next) {
      this._next = next;
    }
  }, {
    key: "isVisited",
    value: function isVisited() {
      return this._isVisited;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DirectedEdge;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "depthFactor",
    value: function depthFactor(currLocation, nextLocation) {
      if (currLocation === _Location.default.EXTERIOR && nextLocation === _Location.default.INTERIOR) return 1;else if (currLocation === _Location.default.INTERIOR && nextLocation === _Location.default.EXTERIOR) return -1;
      return 0;
    }
  }]);

  return DirectedEdge;
}(_EdgeEnd2.default);

exports.default = DirectedEdge;

DirectedEdge.constructor_ = function () {
  this._isForward = null;
  this._isInResult = false;
  this._isVisited = false;
  this._sym = null;
  this._next = null;
  this._nextMin = null;
  this._edgeRing = null;
  this._minEdgeRing = null;
  this._depth = [0, -999, -999];
  var edge = arguments[0],
      isForward = arguments[1];

  _EdgeEnd2.default.constructor_.call(this, edge);

  this._isForward = isForward;

  if (isForward) {
    this.init(edge.getCoordinate(0), edge.getCoordinate(1));
  } else {
    var n = edge.getNumPoints() - 1;
    this.init(edge.getCoordinate(n), edge.getCoordinate(n - 1));
  }

  this.computeDirectedLabel();
};